import { render, staticRenderFns } from "./kanban copy.vue?vue&type=template&id=2c508966&scoped=true&"
import script from "./kanban copy.vue?vue&type=script&lang=js&"
export * from "./kanban copy.vue?vue&type=script&lang=js&"
import style0 from "./kanban copy.vue?vue&type=style&index=0&id=2c508966&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c508966",
  null
  
)

export default component.exports